export class InputDate {
    constructor(element) {
        this.element = element;
        this.date = this.createDate();
        const visualName = element.data("name");
        this.oldValue = this.element.val();
        if (visualName === undefined) {
            throw new Error(`El campo ${element} no tiene la propiedad data-name`);
        }
        this.fieldVisualName = visualName;
    }
    createDate() {
        const dateString = this.element.val();
        if (!dateString) {
            if (this.element.is(":required")) {
                throw new Error(requiredField.replace("{fieldName}", this.fieldVisualName));
            }
            return undefined;
        }
        const date = new Date(dateString.replace(/(\d{2})-(\d{2})-(\d{4})/, "$3-$2-$1"));
        if (isNaN(date.getTime())) {
            throw new Error(incorrectFieldValue.replace("{fieldName}", this.fieldVisualName));
        }
        return date;
    }
    getDaysDifference(other) {
        if (this.empty) {
            return 0;
        }
        if (other instanceof InputDate) {
            if (other.empty) {
                return 0;
            }
            other = other.date;
        }
        return (this.date.getTime() - other.getTime()) / (60 * 60 * 1000);
    }
    get isChanged() {
        return this.element.val() !== this.oldValue;
    }
    get empty() {
        return this.date === undefined;
    }
    get formated() {
        if (this.empty) {
            return "";
        }
        return `${`0${this.date.getUTCDate()}`.slice(-2)}-${`0${this.date.getUTCMonth() + 1}`.slice(-2)}-${this.date.getUTCFullYear()}`;
    }
}
